import React, { FC } from "react";

import MaterialListItemText, { ListItemTextProps } from "@mui/material/ListItemText";

import { IProps } from "./types";

export const ListItemText: FC<IProps & ListItemTextProps> = (props) => (
  <MaterialListItemText {...props as any} />
);
